const Loader = () => (
    <div className="fixed top-0 left-0 z-50 w-full h-full bg-white dark:bg-boxdark opacity-35 dark:opacity-65">
        <div className="flex justify-center items-center mt-[50vh]">
            <div className="w-16 h-16 border-8 border-dashed rounded-full border-primary dark:border-secondary animate-spin"></div>
        </div>
    </div>
)

export default Loader
